export default function AboutSection() {
  return (
    <section id="about" className="scroll-mt-16 py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10">
            关于探花
          </h2>
          <div className="max-w-3xl mx-auto">
            <div className="bg-background-100 rounded-lg border border-background-200/60 p-6 md:p-8">
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                探花系列是一个专注于精品内容资源聚合与导航的综合性平台。自成立以来，我们始终致力于为探花用户提供最稳定、最安全的探花官网入口与探花最新地址发布服务，并持续扩展探花在线免费资源库。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                我们的编辑团队每日精选优质内容，打造探花精选合集，从经典回顾到最新上架，覆盖多元化探花资源类型。无论您是新用户还是资深访客，都能在这里找到心仪的内容入口。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                安全可靠是我们的核心承诺。探花系列采用多重地址备份与实时监控机制，确保探花入口始终可用，让每一位用户都能安心访问。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}